




























import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreateHomeSlider from "./create-homeSlider.vue";
import EditHomeSlider from "./edit-homeSlider.vue";
import Ajax from "../../lib/ajax";
import appconst from '../../lib/appconst';
class PageHomeSliderRequest extends PageRequest {
    name: string;
}

@Component({
    components: { CreateHomeSlider, EditHomeSlider }
})
export default class HomeSliders extends AbpBase {
    edit() {
        this.editModalShow = true;
    }
    //filters
    pagerequest: PageHomeSliderRequest = new PageHomeSliderRequest();

    createModalShow: boolean = false;
    editModalShow: boolean = false;


    get list() {
        return this.$store.state.homeSlider.list;
    }
    get loading() {
        return this.$store.state.homeSlider.loading;
    }
    create() {
        this.createModalShow = true;
    }
    get sliderTypeDic() {
        return {
            0: '球场',
            1: '旅游+打球',
            2: '文章'
        };
    }
    async getpage() {
        this.pagerequest.maxResultCount = 1000;
        this.pagerequest.skipCount = 0;
        //filters

        await this.$store.dispatch({
            type: "homeSlider/getAll",
            data: this.pagerequest
        });
    }

    columns = [
        {
            title: this.L("Picture"),
            key: "ImageUrl",
            render: (h: any, params: any) =>{
                let url = appconst.remoteServiceBaseUrl + params.row.imageUrl;
                return h(
                    "img",
                    {
                        attrs: {
                            src: url
                        },
                        style: {
                            width: '120px'
                        }
                    }
                );
            }
        },
        {
            title: this.L('SliderType'),
            key: "alt",
            render: (h: any, params: any) => {
                return h(
                    "span",
                    this.sliderTypeDic[params.row.alt] || ""
                );
            }
        },
        {
            title: this.L("SliderProductId"),
            key: "linkUrl",
        },
        {
            title: this.L("DisplayOrder"),
            key: "displayOrder"
        },
        {
            title: this.L("Actions"),
            key: "Actions",
            width: 150,
            render: (h: any, params: any) => {
                return h("div", [
                    h(
                        "Button",
                        {
                            props: {
                                type: "primary",
                                size: "small"
                            },
                            style: {
                                marginRight: "5px"
                            },
                            on: {
                                click: () => {
                                    this.$store.commit(
                                        "homeSlider/edit",
                                        params.row
                                    );
                                    this.edit();
                                }
                            }
                        },
                        this.L("Edit")
                    ),
                    h(
                        "Button",
                        {
                            props: {
                                type: "error",
                                size: "small",
                                disabled: params.row.isStatic
                            },
                            on: {
                                click: async () => {
                                    this.$Modal.confirm({
                                        title: this.L("Tips"),
                                        content: this.L(
                                            "HomeSliderDeleteWarningMessage"
                                        ),
                                        okText: this.L("Yes"),
                                        cancelText: this.L("No"),
                                        onOk: async () => {
                                            await this.$store.dispatch({
                                                type: "homeSlider/delete",
                                                data: params.row
                                            });
                                            await this.getpage();
                                        }
                                    });
                                }
                            }
                        },
                        this.L("Delete")
                    )
                ]);
            }
        }
    ];
    async created() {
        this.getpage();
    }
}
